import React, { useContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { LinearProgress } from '@material-ui/core';
import { NavBar, Wrapper } from '@mvrb-frontend/shared-ui';
import { GlobalContext } from '../contexts/GlobalContext';
import { isLoggedIn, logout, isStaffUser, isAdminUser } from '../utils/auth';
import { OrsRoutes } from '../constants/routes';

const Page = (props: any) => {
  const { children, isFetching, container } = props;
  const history = useHistory();
  const content = isFetching ? <LinearProgress /> : children;
  const globalContext = useContext(GlobalContext);
  const [initials, setInitials] = useState<string>('');
  const isStaff = isStaffUser();
  const isAdmin = isAdminUser();
  const isLogged = isLoggedIn();

  useEffect(() => {
    if (!globalContext.profile && isLogged) {
      const profile = Cookies.getJSON('ORS').profile;
      if (profile) {
        globalContext.setProfile(profile);
      } else {
        clearAuth();
        history.push(process.env.REACT_APP_ORS_BASE_URL || '/');
      }
    }
  }, [globalContext.profile]);

  useEffect(() => {
    if (!globalContext.profile || !isLogged) {
      return setInitials('');
    }
    return setInitials(`
      ${globalContext.profile?.firstName?.charAt(0).toUpperCase()}
      ${globalContext.profile?.lastName?.charAt(0).toUpperCase()}`);
  }, [globalContext.profile]);

  function clearAuth() {
    logout();
    globalContext.setProfile(undefined);
  }

  const isAdminOrStaff = () => {
    if (isAdmin || isStaff) {
      return true;
    } else {
      return false;
    }
  };

  const navBar: React.ReactElement = (
    <NavBar
      authActionSubmit={() => {
        if (isLogged) {
          clearAuth();
        }
        // history.push I believe is relative, so / should get us to /ors
        history.push(process.env.REACT_APP_ORS_BASE_URL || '/');
      }}
      links={[
        {
          title: 'Home',
          value: `${process.env.REACT_APP_WEBSITE_BASE_URL}`, // href, so should be just the domain /
        },
        {
          title: 'Reviews',
          value: `${process.env.REACT_APP_WEBSITE_BASE_URL}reviews`,
        },
        {
          title: 'Analytics Dashboard',
          value: `/ors${OrsRoutes.AnalyticsDashboard}`,
        },
        {
          title: 'User Manual',
          value: process.env.REACT_APP_USER_MANUAL_PDF_URL,
          onClick: () => window.open(process.env.REACT_APP_USER_MANUAL_PDF_URL, '_blank'),
        },
        {
          title: 'System Management',
          value: `/ors${OrsRoutes.Users}`,
          visible: isAdminOrStaff(),
        },
      ]}
      loggedIn={isLogged}
      userInitials={initials}
      onUserInitialClick={() => history.push('/edit-user-profile')}
      newsLetterOrigin={'ors-frontend'}
    />
  );

  return (
    <Wrapper isFetching={isFetching} navBar={navBar} container={container}>
      {content}
    </Wrapper>
  );
};

Page.propTypes = {
  children: PropTypes.any.isRequired,
  isFetching: PropTypes.bool.isRequired,
  container: PropTypes.bool,
};

export default Page;
